/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CoupleStudioRoomPreferenceCleanupResultDto } from '../models/CoupleStudioRoomPreferenceCleanupResultDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class CoupleStudioRoomPreferenceCleanupService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns CoupleStudioRoomPreferenceCleanupResultDto OK
     * @throws ApiError
     */
    public postApiHousingCoupleStudioRoomPreferenceCleanupPreviewCleanup(): CancelablePromise<CoupleStudioRoomPreferenceCleanupResultDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/CoupleStudioRoomPreferenceCleanup/PreviewCleanup',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns CoupleStudioRoomPreferenceCleanupResultDto OK
     * @throws ApiError
     */
    public postApiHousingCoupleStudioRoomPreferenceCleanupExecuteCleanup(
        requestBody?: Array<string>,
    ): CancelablePromise<CoupleStudioRoomPreferenceCleanupResultDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/CoupleStudioRoomPreferenceCleanup/ExecuteCleanup',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
